define(['jquery','sweetalert2', 'core/url', 'core/str'],
function($, Swal, moodleurl, str) {
    var index = {
        dom: {
            main: null
        },
        langs: {
            congratulations: null,
            subscriptionRenewed: null,
            exploreitrack: null,
            paymentFailed: null,
            paymentFailedMessage: null,
            goToDashboard: null,
        },
        action: {
            getString: function(success) {
                str.get_strings([
                    {key: 'congratulations', component: 'local_custom_auth'},
                    {key: 'subscriptionRenewed', component: 'local_custom_auth'},
                    {key: 'exploreitrack', component: 'local_custom_auth'},
                    {key: 'paymentFailed', component: 'local_custom_auth'},
                    {key: 'paymentFailedMessage', component: 'local_custom_auth'},
                    {key: 'goToDashboard', component: 'local_custom_auth'},
                ]).then(function(s) {
                    index.langs.congratulations = s[0];
                    index.langs.subscriptionRenewed = s[1];
                    index.langs.exploreitrack = s[2];
                    index.langs.paymentFailed = s[3];
                    index.langs.paymentFailedMessage = s[4];
                    index.langs.goToDashboard = s[5];
                    index.init(success);
                }).fail(function() {});
            },
        },
        init: function(success) {
            var status = success;
                if (status) {                    
                    Swal.fire({
                        title: index.langs.congratulations,
                        text: index.langs.subscriptionRenewed,
                        icon: "success",
                        footer: '<a href="'+moodleurl.relativeUrl('/') + '">'+index.langs.exploreitrack+'</a>',
                        showCancelButton: false,
                        showConfirmButton: false
                    });
                   
                }
                else{
                    Swal.fire({
                        title: index.langs.paymentFailed,
                        text: index.langs.paymentFailedMessage,
                        icon: "warning",
                        footer: '<a href="'+moodleurl.relativeUrl('/') + '">'+index.langs.goToDashboard +'</a>',
                        showCancelButton: false,
                        showConfirmButton: false
                    });
                }
        }
    };
    return {
        init: index.action.getString
    };
});